package vegasful.admin

import org.jetbrains.compose.web.css.*

/**
 * Constants for the Admin UI
 */
object Theme {
    val mainHeaderBackgroundColor by variable<CSSColorValue>()

    val mainLayoutBackgroundColor by variable<CSSColorValue>()
    val containerHeaderBackgroundColor by variable<CSSColorValue>()
    val containerContentBackgroundColor by variable<CSSColorValue>()
    val borderDividerDefault by variable<CSSColorValue>()

    val textColor by variable<CSSColorValue>()
    val subtleTextColor by variable<CSSColorValue>()
    val disabledTextColor by variable<CSSColorValue>()
    val tabsBorder by variable<CSSColorValue>()

    val brandColor by variable<CSSColorValue>()
    val highlightColor by variable<CSSColorValue>()

    val defaultDivider by variable<CSSColorValue>()

    val buttonBackgroundNormal by variable<CSSColorValue>()
    val buttonBackgroundNormalHover by variable<CSSColorValue>()
    val buttonForegroundNormal by variable<CSSColorValue>()
    val buttonForegroundNormalHover by variable<CSSColorValue>()
    val buttonBorderNormal by variable<CSSColorValue>()
    val buttonBackgroundPrimary by variable<CSSColorValue>()
    val buttonBackgroundPrimaryHover by variable<CSSColorValue>()
    val buttonForegroundPrimary by variable<CSSColorValue>()

    // message boxes
    val messageInfoBorder by variable<CSSColorValue>()
    val messageInfoBackground by variable<CSSColorValue>()

    val messageWarnBorder by variable<CSSColorValue>()
    val messageWarnBackground by variable<CSSColorValue>()

    val messageAlertBorder by variable<CSSColorValue>()
    val messageAlertBackground by variable<CSSColorValue>()

    val smallFontSize by variable<CSSNumeric>()
}

object AppStylesheet : StyleSheet() {
    init {
        val brandColor = rgb(27, 17, 122)
        universal style {
            Theme.mainHeaderBackgroundColor(Color.black)
            Theme.mainLayoutBackgroundColor(Color("#f2f3f3"))
            Theme.borderDividerDefault(Color("#eaeded"))
            Theme.containerHeaderBackgroundColor(Color("#fafafa"))
            Theme.containerContentBackgroundColor(Color("#ffffff"))

            Theme.tabsBorder(Color("#aab7b8"))

            Theme.textColor(rgb(22, 25, 31))
            Theme.subtleTextColor(rgb(84, 91, 100))
            Theme.disabledTextColor(Color("#aab7b8"))

            Theme.brandColor(brandColor)
            Theme.highlightColor(Color("#C4169C"))
            Theme.defaultDivider(Color("#eaeded"))

            Theme.smallFontSize((0.9).cssRem)

            Theme.buttonBackgroundNormal(Color.white)
            Theme.buttonBackgroundNormalHover(Color("#fafafa"))
            Theme.buttonForegroundNormal(Color("#545b64"))
            Theme.buttonForegroundNormalHover(Color("#16191f"))
            Theme.buttonBorderNormal(Color("#545b64"))
            Theme.buttonBackgroundPrimary(brandColor)
            Theme.buttonBackgroundPrimaryHover(Color("#0051E6"))
            Theme.buttonForegroundPrimary(Color.white)

            Theme.messageInfoBorder(Color("#0073bb"))
            Theme.messageInfoBackground(Color("#f1faff"))

            Theme.messageWarnBorder(Color("#0073bb"))
            Theme.messageWarnBackground(Color("#f1faff"))

            Theme.messageAlertBorder(Color("#d13212"))
            Theme.messageAlertBackground(Color("#fdf3f1"))

            boxSizing("border-box")
        }

        type("html") style {
            fontFamily("HCo Gotham", "Arial", "Helvetica", "sans-serif")
            color(Theme.textColor.value())
            fontSize(90.percent)
        }

        type("A") style {
            color(Theme.buttonBackgroundPrimary.value())

        }

        (type("A") + hover) style {
            color(Theme.buttonBackgroundPrimaryHover.value())
        }

        type("input,textarea") style {
            border(1.px, LineStyle.Solid, Theme.tabsBorder.value())
            borderRadius(2.px)
            padding((0.4).cssRem, (0.6).cssRem)
        }

        type("select") style {
            border(1.px, LineStyle.Solid, Theme.tabsBorder.value())
            borderRadius(2.px)
            padding((0.4).cssRem, (0.6).cssRem)
        }
    }
}